import React from 'react';
import AdminShell from './layout/AdminShell';
import HomeContentSettings from './HomeContentSettings';

/** Client-reported: tutorial videos, App Update settings, testimonials,
 * guidelines, the Snapmaster Agreement and both apps' Terms & Conditions
 * were all crowded onto the bottom of the Dashboard — moved to their own
 * tab. HomeContentSettings itself is unchanged; this is just its own
 * AdminShell page instead of being embedded in Home.tsx. */
export default function ContentPage() {
    return (
        <AdminShell activePage="content" title="App Content" subtitle="Tutorial videos, app update, testimonials, guidelines, agreement & terms shown in the apps">
            <HomeContentSettings />
        </AdminShell>
    );
}
